import { AvailableAppSubscription } from '../types/AvailableAppSubscription';
import { ScanPackage } from '../types/ScanPackageType';

export const REVENUECAT_SUBSCRIPTION_IDS = [
  'mobile_subscription',
  'desktop_subscription',
];

export const AVAILABLE_SUBSCRIPTIONS: AvailableAppSubscription[] = [
  {
    product_id: 'mobile_subscription',
    name: 'Mobile',
    type: 'mobile',
    mobileAccess: true,
    webAccess: false,
    billingSheets: '5',
    discountedRetrospectiveAudit: false,
    monthlyCost: 4.99,
  },
  {
    product_id: 'desktop_subscription',
    name: 'Desktop',
    type: 'desktop',
    mobileAccess: true,
    webAccess: true,
    billingSheets: 'unlimited',
    discountedRetrospectiveAudit: false,
    monthlyCost: 39.99,
  },
  {
    product_id: 'enterprise_subscription',
    name: 'Enterprise',
    type: 'enterprise',
    mobileAccess: true,
    webAccess: true,
    billingSheets: 'unlimited',
    discountedRetrospectiveAudit: true,
    monthlyCost: 0,
  },
];

export const AVAILABLE_SCAN_PACKAGES: ScanPackage[] = [
  {
    product_id: 'scan_package_1',
    name: '1 Scan',
    cost: 2.99,
    discount: '',
  },
  {
    product_id: 'scan_package_10',
    name: '10 Scans',
    cost: 23.99,
    discount: '20%',
  },
  {
    product_id: 'scan_package_25',
    name: '25 Scans',
    cost: 54.99,
    discount: '24%',
  },
  {
    product_id: 'scan_package_100',
    name: '100 Scans',
    cost: 219.99,
    discount: '27%',
  },
];

export const APPLE_UNSUBSCRIBE_URL =
  'https://apps.apple.com/account/subscriptions';

export const GOOGLE_UNSUBSCRIBE_URL =
  'https://play.google.com/store/account/subscriptions';

export const WEB_UNSUBSCRIBE_URL = 'https://app.galeai.co/subscriptions';
